<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

  export default {
    name: 'App',
    // components: {
    //   HelloWorld
    // }
    // mounted() {
    //   // 页面加载时判断是否为刷新 
    //   const isReloaded = sessionStorage.getItem('isReloading');
    //   if (isReloaded) {
    //     sessionStorage.removeItem('isReloading');  // 清除标记
    //   } else {
    //     localStorage.removeItem('token');  // 关闭后重新打开，清除数据 
    //   }

    //   // 监听页面关闭/刷新事件 
    //   window.addEventListener('beforeunload', () => {
    //     sessionStorage.setItem('isReloading', 'true'); // 设置刷新标记
    //   });
    // }
    created() {
      // 首次加载或关闭后重新打开时清除数据 
      if (!sessionStorage.getItem('isReloading')) {
        localStorage.removeItem('token');
      }
      // 监听页面刷新行为 
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('isReloading', 'true');
      });
      // 清除标记避免影响后续关闭 
      window.addEventListener('load', () => {
        sessionStorage.removeItem('isReloading');
      });
    },
  }
</script>

<style>
  #app {
    /* font-family: 'dengxian', serif; */
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #fff;
  }
</style>